/*
 * Copyright (c) 2021 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.project-detail.payments', {
            parent: 'board.project-detail',
            url: '/payments?type',
            data: {
                authorities: ['ROLE_BOARD','ROLE_MANAGER', 'ROLE_FINANCE'],
                pageTitle: 'askApp.project.payment.title'
            },
            views: {
                'projectDetail@board.project-detail': {
                    templateUrl: 'app/board/project/detail/payments/payments.html',
                    controller: 'ProjectPaymentsController',
                    controllerAs: 'vm'
                }
            },
            params: {
                type: {
                    value: 'all',
                    squash: true
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('enumPaymentCategory');
                    return $translate.refresh();
                }]
            }
        })
        .state('board.project-detail.payments.edit', {
            parent: 'board.project-detail.payments',
            url: '/{paymentId}/edit',
            data: {
                authorities: ['ROLE_FINANCE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'entity', function($stateParams, $state, $uibModal, entity) {
                $uibModal.open({
                    templateUrl: 'app/board/project/detail/payments/payment-dialog.html',
                    controller: 'ProjectPaymentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: ['BoardPayment', function(BoardPayment) {
                            return BoardPayment.get({id : $stateParams.paymentId}).$promise;
                        }],
                        entityProject: entity
                    }
                }).result.then(function() {
                    $state.go('board.project-detail.payments', null, { reload: 'board.project-detail.payments' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
